/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CheckoutFormRendererQueryVariables = {
    orgRelayId: string;
};
export type CheckoutFormRendererQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"MixedCheckoutForm_viewer">;
    };
    readonly org: {
        readonly id?: string | undefined;
        readonly experiments?: ReadonlyArray<string | null> | null | undefined;
        readonly userTeams?: {
            readonly __typename: "TeamList";
            readonly list: ReadonlyArray<{
                readonly teamId: string;
                readonly " $fragmentRefs": FragmentRefs<"MixedCheckoutForm_team">;
            }>;
        } | {
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
            readonly message: string | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        } | undefined;
        readonly " $fragmentRefs": FragmentRefs<"MixedCheckoutForm_org">;
    } | null;
};
export type CheckoutFormRendererQuery = {
    readonly response: CheckoutFormRendererQueryResponse;
    readonly variables: CheckoutFormRendererQueryVariables;
};



/*
query CheckoutFormRendererQuery(
  $orgRelayId: ID!
) {
  viewer {
    ...MixedCheckoutForm_viewer
    id
  }
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...MixedCheckoutForm_org
      id
      experiments
      userTeams {
        __typename
        ... on TeamList {
          list {
            teamId
            ...MixedCheckoutForm_team
            id
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
    id
  }
}

fragment LocalizedAddressForm_org on Org {
  id
}

fragment MixedCheckoutForm_org on Org {
  ...OrgUserSelectForm_org
  ...TeamJoinCreateDialog_org
  ...PaymentConfirmation_org
  ...LocalizedAddressForm_org
  id
  currentOrgPersons {
    __typename
    ... on OrgPersonList {
      list {
        __typename
        id
        primaryCalendarId
        isYou
        userId
        personId
        profile {
          givenName
          familyName
          externalImageUrl
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
  name
  experiments
  primaryOrgEmail
  primaryOrgCalendar
  primaryTeam {
    __typename
    ... on Team {
      teamId
      teamName
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  userTeams {
    __typename
    ... on TeamList {
      ...TeamPicker_userTeams
      list {
        teamId
        id
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        id
        name
        syncSources {
          type
          value
          id
        }
        subscription {
          __typename
          ... on SubscriptionDetails {
            subscription {
              id
              productType
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
}

fragment MixedCheckoutForm_team on Team {
  ...PaymentConfirmation_team
  teamName
  teamId
  teamMembers {
    person {
      personId
      profile {
        givenName
        familyName
      }
      id
    }
  }
  invitedMembers {
    person {
      personId
      profile {
        givenName
        familyName
      }
      id
    }
  }
}

fragment MixedCheckoutForm_viewer on Viewer {
  id
  ...OrgUserSelectForm_viewer
}

fragment OrgUserSelectForm_org on Org {
  id
  experiments
  currentOrgPersons {
    __typename
    ... on GraphEntityError {
      message
    }
    ... on OrgPersonList {
      list {
        userId
        primaryCalendarId
        calendarAliases
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        id
      }
    }
  }
}

fragment OrgUserSelectForm_viewer on Viewer {
  orgPersonQueryResultErrorable(query: "", orgRelayId: "") {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on OrgPersonQueryResult {
      query
      persons {
        userId
        primaryCalendarId
        calendarAliases
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        id
      }
    }
  }
}

fragment PaymentConfirmation_org on Org {
  id
  primaryTeam {
    __typename
    ... on Team {
      teamId
      teamName
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment PaymentConfirmation_team on Team {
  teamName
  teamId
  teamMembers {
    person {
      profile {
        givenName
        familyName
      }
      id
    }
  }
}

fragment TeamJoinCreateDialog_org on Org {
  ...TeamJoinCreate_org
  id
  primaryOrgCalendar
}

fragment TeamJoinCreate_org on Org {
  id
  ...TeamSettingsSearch_org
  ...TeamSearchInputRenderer_org
  primaryOrgCalendar
  orgPersonForUserErrorable {
    __typename
    ... on OrgPerson {
      personId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  primaryTeam {
    __typename
    ... on Team {
      teamId
      teamName
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        id
        name
        syncSources {
          type
          value
          id
        }
        subscription {
          __typename
          ... on SubscriptionDetails {
            subscription {
              id
              productType
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  userTeams {
    __typename
    ... on TeamList {
      list {
        id
        teamId
        teamName
        createdBy {
          value
          id
        }
        teamCalendarId
        settings {
          __typename
          ... on TeamSettings {
            manageTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        userSettings {
          __typename
          ... on TeamUserSettings {
            useTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        teamMembers {
          person {
            __typename
            id
            primaryCalendarId
            isYou
            userId
            personId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
        invitedMembers {
          person {
            __typename
            id
            primaryCalendarId
            isYou
            userId
            personId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
      }
    }
  }
  suggestedTeams {
    __typename
    ... on SuggestedTeamList {
      list {
        team {
          id
          teamId
          teamName
          createdBy {
            value
            id
          }
          teamMembers {
            person {
              __typename
              id
              primaryCalendarId
              isYou
              userId
              personId
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
          }
          invitedMembers {
            person {
              __typename
              id
              primaryCalendarId
              isYou
              userId
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
          }
        }
        reasons {
          type
          value
        }
        score
      }
    }
  }
}

fragment TeamPicker_userTeams on TeamList {
  list {
    teamId
    teamName
    id
  }
}

fragment TeamSearchInputRenderer_org on Org {
  id
}

fragment TeamSettingsSearch_org on Org {
  ...TeamSettingsTeammate_org
  id
  primaryOrgCalendar
  workingGroups(first: 1000000) {
    edges {
      node {
        calendarIds
        id
      }
    }
  }
}

fragment TeamSettingsTeammate_org on Org {
  id
  primaryOrgEmail
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "experiments",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v8 = {
        "kind": "InlineFragment",
        "selections": [
            (v6 /*: any*/),
            (v7 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarAliases",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v14 = {
        "kind": "InlineFragment",
        "selections": [
            (v7 /*: any*/),
            (v6 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v16 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamName",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            (v20 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    } as any, v22 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                (v4 /*: any*/),
                (v2 /*: any*/),
                (v10 /*: any*/),
                (v13 /*: any*/),
                (v9 /*: any*/),
                (v15 /*: any*/),
                (v12 /*: any*/)
            ],
            "storageKey": null
        } as any
    ], v23 = {
        "alias": null,
        "args": null,
        "concreteType": "TeamMember",
        "kind": "LinkedField",
        "name": "teamMembers",
        "plural": true,
        "selections": (v22 /*: any*/),
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CheckoutFormRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "MixedCheckoutForm_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "userTeams",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Team",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "MixedCheckoutForm_team"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TeamList",
                                            "abstractKey": null
                                        },
                                        (v8 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "MixedCheckoutForm_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CheckoutFormRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orgRelayId",
                                    "value": ""
                                },
                                {
                                    "kind": "Literal",
                                    "name": "query",
                                    "value": ""
                                }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "orgPersonQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v8 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "query",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgPerson",
                                            "kind": "LinkedField",
                                            "name": "persons",
                                            "plural": true,
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v10 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v13 /*: any*/),
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "OrgPersonQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": "orgPersonQueryResultErrorable(orgRelayId:\"\",query:\"\")"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "currentOrgPersons",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v14 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "OrgPerson",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v2 /*: any*/),
                                                        (v4 /*: any*/),
                                                        (v15 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgPersonList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgEmail",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "WorkingGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "workingGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "WorkingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarIds",
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "workingGroups(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgPersonForUserErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v15 /*: any*/)
                                            ],
                                            "type": "OrgPerson",
                                            "abstractKey": null
                                        },
                                        (v16 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "primaryTeam",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v17 /*: any*/)
                                            ],
                                            "type": "Team",
                                            "abstractKey": null
                                        },
                                        (v8 /*: any*/),
                                        (v16 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "billingGroups",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "BillingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v18 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Urn",
                                                            "kind": "LinkedField",
                                                            "name": "syncSources",
                                                            "plural": true,
                                                            "selections": [
                                                                (v19 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PaymentSubscription",
                                                                            "kind": "LinkedField",
                                                                            "name": "subscription",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "productType",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SubscriptionDetails",
                                                                    "abstractKey": null
                                                                },
                                                                (v14 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "BillingGroupList",
                                            "abstractKey": null
                                        },
                                        (v14 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "userTeams",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Team",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v5 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v21 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamCalendarId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "settings",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "manageTeamCalendar",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v16 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "useTeamCalendar",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamUserSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v16 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v23 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamMember",
                                                            "kind": "LinkedField",
                                                            "name": "invitedMembers",
                                                            "plural": true,
                                                            "selections": (v22 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TeamList",
                                            "abstractKey": null
                                        },
                                        (v8 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "suggestedTeams",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SuggestedTeam",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Team",
                                                            "kind": "LinkedField",
                                                            "name": "team",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v5 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v21 /*: any*/),
                                                                (v23 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TeamMember",
                                                                    "kind": "LinkedField",
                                                                    "name": "invitedMembers",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "OrgPerson",
                                                                            "kind": "LinkedField",
                                                                            "name": "person",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                (v2 /*: any*/),
                                                                                (v10 /*: any*/),
                                                                                (v13 /*: any*/),
                                                                                (v9 /*: any*/),
                                                                                (v12 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SuggestedTeamReason",
                                                            "kind": "LinkedField",
                                                            "name": "reasons",
                                                            "plural": true,
                                                            "selections": [
                                                                (v19 /*: any*/),
                                                                (v20 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "score",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "SuggestedTeamList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                (v18 /*: any*/)
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "2b2d1dacb250e61de8fad5af83ac5cfe",
            "id": null,
            "metadata": {},
            "name": "CheckoutFormRendererQuery",
            "operationKind": "query",
            "text": "query CheckoutFormRendererQuery(\n  $orgRelayId: ID!\n) {\n  viewer {\n    ...MixedCheckoutForm_viewer\n    id\n  }\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...MixedCheckoutForm_org\n      id\n      experiments\n      userTeams {\n        __typename\n        ... on TeamList {\n          list {\n            teamId\n            ...MixedCheckoutForm_team\n            id\n          }\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment LocalizedAddressForm_org on Org {\n  id\n}\n\nfragment MixedCheckoutForm_org on Org {\n  ...OrgUserSelectForm_org\n  ...TeamJoinCreateDialog_org\n  ...PaymentConfirmation_org\n  ...LocalizedAddressForm_org\n  id\n  currentOrgPersons {\n    __typename\n    ... on OrgPersonList {\n      list {\n        __typename\n        id\n        primaryCalendarId\n        isYou\n        userId\n        personId\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n  name\n  experiments\n  primaryOrgEmail\n  primaryOrgCalendar\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      ...TeamPicker_userTeams\n      list {\n        teamId\n        id\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        syncSources {\n          type\n          value\n          id\n        }\n        subscription {\n          __typename\n          ... on SubscriptionDetails {\n            subscription {\n              id\n              productType\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n}\n\nfragment MixedCheckoutForm_team on Team {\n  ...PaymentConfirmation_team\n  teamName\n  teamId\n  teamMembers {\n    person {\n      personId\n      profile {\n        givenName\n        familyName\n      }\n      id\n    }\n  }\n  invitedMembers {\n    person {\n      personId\n      profile {\n        givenName\n        familyName\n      }\n      id\n    }\n  }\n}\n\nfragment MixedCheckoutForm_viewer on Viewer {\n  id\n  ...OrgUserSelectForm_viewer\n}\n\nfragment OrgUserSelectForm_org on Org {\n  id\n  experiments\n  currentOrgPersons {\n    __typename\n    ... on GraphEntityError {\n      message\n    }\n    ... on OrgPersonList {\n      list {\n        userId\n        primaryCalendarId\n        calendarAliases\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        id\n      }\n    }\n  }\n}\n\nfragment OrgUserSelectForm_viewer on Viewer {\n  orgPersonQueryResultErrorable(query: \"\", orgRelayId: \"\") {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on OrgPersonQueryResult {\n      query\n      persons {\n        userId\n        primaryCalendarId\n        calendarAliases\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        id\n      }\n    }\n  }\n}\n\nfragment PaymentConfirmation_org on Org {\n  id\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment PaymentConfirmation_team on Team {\n  teamName\n  teamId\n  teamMembers {\n    person {\n      profile {\n        givenName\n        familyName\n      }\n      id\n    }\n  }\n}\n\nfragment TeamJoinCreateDialog_org on Org {\n  ...TeamJoinCreate_org\n  id\n  primaryOrgCalendar\n}\n\nfragment TeamJoinCreate_org on Org {\n  id\n  ...TeamSettingsSearch_org\n  ...TeamSearchInputRenderer_org\n  primaryOrgCalendar\n  orgPersonForUserErrorable {\n    __typename\n    ... on OrgPerson {\n      personId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        syncSources {\n          type\n          value\n          id\n        }\n        subscription {\n          __typename\n          ... on SubscriptionDetails {\n            subscription {\n              id\n              productType\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamCalendarId\n        settings {\n          __typename\n          ... on TeamSettings {\n            manageTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        userSettings {\n          __typename\n          ... on TeamUserSettings {\n            useTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        teamMembers {\n          person {\n            __typename\n            id\n            primaryCalendarId\n            isYou\n            userId\n            personId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n        invitedMembers {\n          person {\n            __typename\n            id\n            primaryCalendarId\n            isYou\n            userId\n            personId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n      }\n    }\n  }\n  suggestedTeams {\n    __typename\n    ... on SuggestedTeamList {\n      list {\n        team {\n          id\n          teamId\n          teamName\n          createdBy {\n            value\n            id\n          }\n          teamMembers {\n            person {\n              __typename\n              id\n              primaryCalendarId\n              isYou\n              userId\n              personId\n              profile {\n                givenName\n                familyName\n                externalImageUrl\n              }\n            }\n          }\n          invitedMembers {\n            person {\n              __typename\n              id\n              primaryCalendarId\n              isYou\n              userId\n              profile {\n                givenName\n                familyName\n                externalImageUrl\n              }\n            }\n          }\n        }\n        reasons {\n          type\n          value\n        }\n        score\n      }\n    }\n  }\n}\n\nfragment TeamPicker_userTeams on TeamList {\n  list {\n    teamId\n    teamName\n    id\n  }\n}\n\nfragment TeamSearchInputRenderer_org on Org {\n  id\n}\n\nfragment TeamSettingsSearch_org on Org {\n  ...TeamSettingsTeammate_org\n  id\n  primaryOrgCalendar\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        calendarIds\n        id\n      }\n    }\n  }\n}\n\nfragment TeamSettingsTeammate_org on Org {\n  id\n  primaryOrgEmail\n}\n"
        }
    } as any;
})();
(node as any).hash = 'b9c7883ee1e1fa19af03a189721df812';
export default node;
